import React, { useState, useEffect } from 'react'
import {
  UpdateUserVspStatus,
  fetchPlacementDrives,
  fetchPlacementDrivesCandidateById
} from '../../features/constants/apis' // Correct API functions
import { Row, Button, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'
import DataTable, { createTheme } from 'react-data-table-component'
import Header from '../layout/Header/Header'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from '../../AxiosConfig'
import { connect } from 'react-redux'
import { showCandidateProfilePreviewModal } from '../../features/popup/offcanvasSlice'

const PlacemnetDriveCandidateList = ({ authToken, ID, Role, showCandidateProfilePreviewModal }) => {
  // use navigate
  const navigate = useNavigate()

  // use location
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const pdID = queryParams.get('ID')

  // all use state mentioned here
  const [jobApplicationList, setJobApplicationList] = useState([])
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [currnetState, setCurrnetState] = useState()
  const [placemenetDriveCanidateList, setPlacemenetDriveCanidateList] =
    useState([])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await fetchPlacementDrives(authToken)
        setJobApplicationList(response.data)
        console.log('job application data: ', response.data)
      } catch (error) {
        console.error('Error fetching users:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
    fetchPlacementDriveCandidateData()
  }, [authToken])
  const fetchPlacementDriveCandidateData = async () => {
    setLoading(true)
    try {
      const response = await fetchPlacementDrivesCandidateById(
        authToken,
        pdID
      )
      setPlacemenetDriveCanidateList(response.data)
      console.log('placement drive candidate data: ', response.data)
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleUpdateVspStatus = async userID => {
    const currentUser = jobApplicationList.find(user => user.ID === userID) // Find the current user
    if (!currentUser) return

    const currentStatus = currentUser.VspStatus // Get the current VspStatus
    const newStatus = !currentStatus // Toggle the status

    try {
      setLoading(true)
      await UpdateUserVspStatus(authToken, userID) // Call the API to update the status

      // Update the local state to reflect the new status
      setJobApplicationList(prevUsers =>
        prevUsers.map(user =>
          user.ID === userID ? { ...user, VspStatus: newStatus } : user
        )
      )

      setShowModal(false) // Close the modal after the update
    } catch (error) {
      console.error('Error updating VSP status:', error)
    } finally {
      setLoading(false) // End the loading state
    }
  }

  const handelOpenModal = (ID, UserId, VspStatus) => {
    if (VspStatus === true) {
      navigate(`/vps-verification?candidateID=${UserId}&status=${VspStatus}`)
    }
    setSelectedUser({ ID: ID, UserId: UserId, VspStatus: VspStatus })
    setShowModal(true)
  }
  console.log('UserID: ', selectedUser)
  const handelCloseModal = () => {
    setShowModal(false)
    setSelectedUser(null)
  }

  const desiredColumns = [
    {
      name: 'ID',
      selector: row => row.ID, // Get the ID directly
      sortable: true,
      wrap: false,
      width: '80px',
      style: {
        minWidth: '30px'
      }
    },
    {
      name: 'Name',
      selector: row => row.FullName, // Correctly map FullName
      width: '150px',
      sortable: true,
      wrap: false,
      // style: {
      //   width: 'auto',
      //   minWidth: '30px'
      // }
    },
    {
      name: 'Phone',
      selector: row => row.Phone, // Correctly map Phone number
      width: '150px',
      sortable: true,
      wrap: false,
      // style: {
      //   width: 'auto',
      //   minWidth: '30px'
      // }
    },
    {
      name: 'Email',
      selector: row => row.Email, // Correctly map Phone number
      sortable: true,
      wrap: false,
      width: '250px'
    },
    {
      name: 'Location',
      selector: row => row.Location, // Correctly map Phone number
      width: 'auto',
      sortable: true,
      wrap: false,
      style: {
        width: 'auto',
        minWidth: '30px'
      }
    },
    {
      name: 'Status',
      selector: row => {
        return (
          <span>{row.Status}</span>
        )
      }, // Correctly map Phone number
      width: 'auto',
      sortable: true,
      wrap: false,
      style: {
        width: 'auto',
        minWidth: '30px'
      }
    },
    {
      name: 'View',
      selector: row => {
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', width: '100%' }}>
              <a
                href="javaScript:void(0)"
                onClick={() => {
                  console.log('CANDIDATE ID', row.ID)
                  showCandidateProfilePreviewModal({candidateProfilePreviewModalVisible: true, hrReviewCandidateID: row.ID})
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>
              </a>
          </div>
        )
      },
      width: 'auto',
      style: {
        textAlign: 'center',       // fallback for basic alignment
        justifyContent: 'flex-end',
        display: 'flex',
      },
    },
    {
      name: 'Action',
      selector: row => {
        let leftButton = ''
        let rightButton = ''
        let lastButton = ''
        let handleAction = () => {}
        let disableButton = ''
        let buttonStyle = ''
        if (row.Status == 'Pending') {
          leftButton = 'Reject'
          rightButton = 'Accept'
          lastButton = 'No Payment'
          handleAction = (actionType, actionID) => {
            let tempLastButton = ''
            if (actionType == 'Accept') {
              tempLastButton = 'Accepted'
            } else if (actionType == 'Reject') {
              tempLastButton = 'Rejected'
            } else if (actionType == 'No Payment') {
              tempLastButton = 'noPayment'
            }
            const updateApplicationStatus = async () => {
              try {
                const response = await axios.put(
                  '/placement-drive/status/update',
                  {
                    applicationId: actionID,
                    // applicationStatus: (actionType == 'Accept') ? 'Accepted' : 'Rejected'
                    applicationStatus: tempLastButton
                  }
                )
                console.log('Response:', response.data)
                fetchPlacementDriveCandidateData()
              } catch (error) {
                console.error('Error updating status:', error)
              }
            }
            updateApplicationStatus();
          }
          disableButton = false
          buttonStyle = 'primary'
        } else if (row.Status == 'Rejected') {
          rightButton = 'Rejected'
          handleAction = (actionType, actionID) => {
            console.log('ACTION TYPE', actionType, actionID)
          }
          disableButton = true
          buttonStyle = 'danger'
        } else if (row.Status == 'Accepted') {
          rightButton = 'Pending Payment'
          handleAction = (actionType, actionID) => {
            console.log('ACTION TYPE', actionType, actionID)
          }
          disableButton = true
          buttonStyle = 'secondary'
        } else if (row.Status == 'noPayment') {
          leftButton = 'Reject'
          rightButton = 'Accept'
          handleAction = (actionType, actionID) => {
            let tempLastButton = ''
            if (actionType == 'Accept') {
              tempLastButton = 'Accepted'
            } else if (actionType == 'Reject') {
              tempLastButton = 'Rejected'
            }
            const updateApplicationStatus = async () => {
              try {
                const response = await axios.put(
                  '/placement-drive/status/update',
                  {
                    applicationId: actionID,
                    // applicationStatus: (actionType == 'Accept') ? 'Accepted' : 'Rejected'
                    applicationStatus: tempLastButton
                  }
                )
                console.log('Response:', response.data)
                fetchPlacementDriveCandidateData()
              } catch (error) {
                console.error('Error updating status:', error)
              }
            }
            updateApplicationStatus();
          }
          disableButton = false
          buttonStyle = 'primary'
        } else if (row.Status == 'Applied') {
          rightButton = 'Applied'
          handleAction = (actionType, actionID) => {
            console.log('ACTION TYPE', actionType, actionID)
          }
          disableButton = true
          buttonStyle = 'success'
        }
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', width: '100%' }}>
            {leftButton && (
              <Button
                className={'px-4'}
                variant={'outline-secondary'}
                size="sm"
                onClick={() => {
                  handleAction(leftButton, row.applicationID)
                }}
              >
                {leftButton}
              </Button>
            )}
            {rightButton && (
              <Button
                className={'px-4'}
                variant={buttonStyle}
                size="sm"
                onClick={() => {
                  handleAction(rightButton, row.applicationID)
                }}
                disabled={disableButton}
              >
                {rightButton}
              </Button>
            )}
            {lastButton && (
              <Button
                className={'px-4'}
                variant={'outline-primary'}
                size="sm"
                onClick={() => {
                  handleAction(lastButton, row.applicationID)
                }}
                disabled={disableButton}
              >
                {lastButton}
              </Button>
            )}
          </div>
        )
      },
      width: '350px',
      style: {
        textAlign: 'right',       // fallback for basic alignment
        justifyContent: 'flex-end',
        display: 'flex',
      },
    }
  ]
  console.log('desiredColumns:', desiredColumns)

  createTheme(
    'solarized',
    {
      background: {
        default: 'transparent'
      },
      context: {
        background: '#CDFFD8',
        text: '#FFFFFF'
      },
      divider: {
        default: '#45A994'
      },
      action: {
        button: 'rgba(0,0,0,.54)',
        hover: 'rgba(0,0,0,.08)',
        disabled: 'rgba(0,0,0,.12)'
      }
    },
    'light'
  )

  return (
    <>
      <Header />
      <div id="appCapsule">
        <div className="section full py-4">
          <div className="container">
            <Button variant="primary mb-2">
              <Link to="/" className="my-2 text-white">
                <FaArrowLeft
                  style={{ width: '15px', height: '15px', marginRight: '7px' }}
                />
                Go to Dashboard
              </Link>
            </Button>
            <h1 className="title text-dark mb-0">
              {placemenetDriveCanidateList?.placementDrive?.Title}
            </h1>
            <p className="mb-0">
              {placemenetDriveCanidateList?.placementDrive?.SubTitle}
            </p>
            <ul
              className="p-0 gap-1 d-flex mt-1"
              style={{ listStyleType: 'none' }}
            >
              <li>
                <span className="badge bg-secondary gap-1">
                  <ion-icon name="location-outline"></ion-icon>
                  {placemenetDriveCanidateList?.placementDrive?.Location}
                </span>
              </li>
              <li>
                <span className="badge bg-secondary gap-1">
                  <ion-icon name="briefcase-outline"></ion-icon>
                  {placemenetDriveCanidateList?.placementDrive?.Openings}
                </span>
              </li>
              <li>
                <span className="badge bg-secondary gap-1">
                  <ion-icon name="globe-outline"></ion-icon>
                  {placemenetDriveCanidateList?.placementDrive?.Domain}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="section full mt-2 mb-4">
          <div className="container">
            <Row className="justify-content-between my-3">
              <div>
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <DataTable
                    className="justify-content-center"
                    columns={desiredColumns}
                    data={placemenetDriveCanidateList?.users}
                    striped={true}
                    theme="solarized"
                    customStyles={{
                      table: {
                        style: {
                          tableLayout: 'auto'
                        }
                      },
                      headCells: {
                        style: {
                          fontWeight: 'bold', // 👈 Make header text bold
                          whiteSpace: 'nowrap',
                          width: 'fit-content'
                        }
                      },
                      cells: {
                        style: {
                          whiteSpace: 'nowrap',
                          width: 'fit-content'
                        }
                      }
                    }}
                    conditionalCellStyles={[
                      {
                        when: (row, rowIndex, column) => column.id === 'actions', // Replace 'actions' with your last column ID
                        style: {
                          justifyContent: 'flex-end',
                          textAlign: 'right',
                        },
                      },
                    ]}
                  />
                )}
              </div>
            </Row>
          </div>
        </div>
      </div>

      {/* confirmation modal is wriiten here  */}
      <Modal show={showModal} onHide={handelCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm VSP Status Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are your Sure you want to{' '}
          {selectedUser?.VspStatus
            ? ' mark this user as Pending'
            : ' verify this user for VSP'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handelCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              navigate(
                `/vps-verification?candidateID=${selectedUser?.UserId}&status=${selectedUser?.VspStatus}`
              )
            }
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authToken, ID, Role } = auth
  return {
    authToken,
    ID,
    Role
  }
}

const mapDispatchToProps = {
  showCandidateProfilePreviewModal
}

export default connect(mapStateToProps, mapDispatchToProps)(PlacemnetDriveCandidateList)
